import React, { lazy, Suspense } from 'react';
import { Router } from '@reach/router';
import { listaMenu } from './helpers/rota.helper';
import { Loading } from './components/molecules/Loading';
import { PrivateRoute } from './helpers/PrivateRoute';

const LoginErro = lazy(() => import('./containers/pages/LoginErro'));
const LoginDev = lazy(() => import('./containers/pages/LoginDev'));
const LoginApp = lazy(() => import('./containers/pages/LoginApp'));
const LoginCallback = lazy(() => import('./containers/pages/LoginCallback'));
const LoginCallbackError = lazy(() =>
    import('./containers/pages/loginCallbackError')
);
const Home = lazy(() => import('./containers/pages/Home'));
// const PrivateRoute = lazy(() => import('./helpers/PrivateRoute'));
const NotFound = lazy(() => import('./containers/pages/NotFound'));
const FormExemple = lazy(() => import('./containers/pages/FormExemple'));

// const Home = lazy(() => {
//     return Promise.all([
//         import('./containers/pages/Home'),
//         new Promise(resolve => setTimeout(resolve, 30000))
//     ])
//         .then(([moduleExports]) => moduleExports);
// });
// const LoginDev = lazy(() => {
//     return Promise.all([
//         import('./containers/pages/LoginDev'),
//         new Promise(resolve => setTimeout(resolve, 30000))
//     ])
//         .then(([moduleExports]) => moduleExports);
// });

const Routes = () => (
    <Suspense fallback={<Loading open />}>
        <Router
            baseuri={`${process.env.REACT_APP_BASE_URL}`}
            basepath={`${process.env.REACT_APP_BASE_URL}`}
        >
            <Home path='/' />
            {listaMenu().map(menu => (
                <PrivateRoute key={menu.path} {...menu} />
            ))}
            {process.env.REACT_APP_NODE_ENV === 'development' ? (
                <LoginDev path='/login' />
            ) : (
                <LoginApp path='/login' />
            )}
            <LoginCallback path='/login-callback/:data' />
            <LoginCallbackError path='/login-callback/' />
            <LoginErro path='/login-error' />
            {process.env.NODE_ENV === 'development' && (
                <FormExemple path='/formularioexemplo' />
            )}
            <NotFound default />
        </Router>
    </Suspense>
);

export default Routes;
